<section class="cooperative-housing-transfer-form">
  <div class="cooperative-housing-transfer-form__header">
    <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  </div>

  @if (form) {
    <form class="cooperative-housing-transfer-form__content astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <section class="astral-section-surface astral-stack-m">
        <h4>{{ 'COOPERATIVE_HOUSING.TRANSFER_INFORMATION' | translate }}</h4>

        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['rentalId']"></astral-input>
          <astral-date-picker [control]="form.controls['transferDate']"></astral-date-picker>
          <astral-select [control]="form.controls['transferType']" [itemsSource]="transferTypes"></astral-select>
          <app-money-box [control]="form.controls['amount']" [round]="true"></app-money-box>
          <app-money-box [control]="form.controls['additionalPayment_639']" [round]="true"></app-money-box>
          <app-money-box [control]="form.controls['innerFund_635']" [round]="true"></app-money-box>
        </astral-layout-group>
      </section>

      <section class="astral-section-surface astral-stack-m">
        <h4>{{ 'COOPERATIVE_HOUSING.TRANSFER_SELLERS' | translate }}</h4>

        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['oldLeaseAgreementNumber']"></astral-input>
        </astral-layout-group>

        <div class="astral-stack-m">
          @for (sellerForm of $any(sellerForms.controls); track sellerForm; let i = $index) {
            <section class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-stack-m">
              <h5>{{ $any(sellerForm).controls['name'].value }}</h5>

              <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                <astral-date-picker [control]="$any(sellerForm).controls['memberTo']"></astral-date-picker>
                <astral-input [control]="$any(sellerForm).controls['ownedShare']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
                <astral-input [control]="$any(sellerForm).controls['soldShare']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
                <astral-date-picker [control]="$any(sellerForm).controls['buyDate_640']"></astral-date-picker>
                <app-money-box [control]="$any(sellerForm).controls['buyAmount_643']"></app-money-box>
                <app-money-box [control]="$any(sellerForm).controls['companyAmortization_636']"></app-money-box>
                <app-money-box [control]="$any(sellerForm).controls['ownerAmortization_636']"></app-money-box>
                <app-money-box [control]="$any(sellerForm).controls['innerFundBuy_644']"></app-money-box>
                <astral-input [control]="$any(sellerForm).controls['email']" [type]="'email'"></astral-input>
                <astral-input [control]="$any(sellerForm).controls['phone']" [type]="'phone'" [inputMode]="'tel'"></astral-input>
                <astral-toggle [control]="$any(sellerForm).controls['acquisitionGiftOrInheritance_642']"></astral-toggle>
              </astral-layout-group>

              <app-postal-address
                [group]="$any(sellerForm).controls['postalAddress']"
                [model]="dataContext.sellers[i].postalAddress"
                [mandatory]="false"
                [title]="''"
              ></app-postal-address>
            </section>
          }
        </div>
      </section>

      <section class="astral-section-surface astral-stack-m">
        <h4>{{ 'COOPERATIVE_HOUSING.TRANSFER_BUYERS' | translate }}</h4>

        <div class="astral-stack-m">
          @for (buyerForm of $any(buyerForms.controls); track buyerForm; let i = $index) {
            <section class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-stack-m">
              <h5>{{ $any(buyerForm).controls['name'].value }}</h5>

              <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input [control]="$any(buyerForm).controls['acquiredShare']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
                <astral-date-picker [control]="$any(buyerForm).controls['memberFrom']"></astral-date-picker>
                <astral-date-picker [control]="$any(buyerForm).controls['approvalDate']"></astral-date-picker>
                <astral-input [control]="$any(buyerForm).controls['email']" [type]="'email'"></astral-input>
                <astral-input [control]="$any(buyerForm).controls['phone']" [type]="'phone'" [inputMode]="'tel'"></astral-input>
              </astral-layout-group>
            </section>
          }
        </div>
      </section>
    </form>
  }
</section>
